const TickIcon = ({
  className = '',
  stroke = '#0FD08B',
  id = 'tick-icon'
}: {
  className?: string
  stroke?: string
  id?: string
}) => (
  <svg
    className={className}
    id={id}
    width='16'
    height='12'
    viewBox='0 0 16 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2 6L6 10L14 2'
      stroke={stroke}
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
  </svg>
)

export default TickIcon
